import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=e2900d44&lang=pug"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=e2900d44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports